import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import requestOTALink from './requestOTALink';

/**
 * @deprecated please use `requestOTALink`
 *
 * Request a magic link.  The API will create a nonce and trigger an event so that the nonce can be communicated to the user (via email, for example). The user can then call `redeemMagicLink(nonce)` to log in with the magic link.
 *
 * @param email
 *
 * @returns __Promise__ which resolves to `true` if successful.
 *
 * <details>
 * <summary>
 * On error (throws)
 * <p><span style="background-color:rgb(255, 99, 71); margin-right:1.25em; display:inline-block;"> &nbsp; Deprecated &nbsp; </span></p>
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/Authentication/requestMagicLink
 * ```
 * </details>
 */
export default function requestMagicLink(
  email: string,
  recaptchaToken?: string
): Promise<boolean | APIErrorResponse> {
  console.warn('[Arc Identity SDK]: requestMagicLink is deprecated');
  return requestOTALink(email, recaptchaToken);
}
